import React, { Component } from 'react'
import './Warehousing.css'
// let warehouse='Details not available'
class Warehousing extends Component {
    constructor(props) {
        super(props)

        this.state = {
            warehouse: 'Details not available'
        }
    }

    // componentWillReceiveProps(nextProps){
    //     warehouse=nextProps.transporter_data.warehousing_services;
    //     if(warehouse===undefined || warehouse===null){
    //         warehouse='Details not available'
    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        // warehouse=nextProps.transporter_data.warehousing_services;
        // if(warehouse === undefined || warehouse === null){
        //     warehouse='Details not available'
        // }

        if (nextProps.transporter_data.warehousing_services === undefined || nextProps.transporter_data.warehousing_services === null) {
            return {
                warehouse: 'Details not available'
            }
        }
        else {
            return {
                warehouse: nextProps.transporter_data.warehousing_services

            }
        }
    }

    render() {
        const { warehouse } = this.state
        if (warehouse.provideService === "yes" || warehouse.provideService === "Yes" || warehouse.provideService === "1" || warehouse.provideService === 1) {
            return (
                <>
                    <div className="warehousingcard s-ware">
                        <div className="warehousingcontainer row">
                            <div className="col-12">
                                <span className="data_header"><b>Warehousing Services</b></span>
                            </div>
                            <div className="col">
                                <div className="warehousing"><span>{(warehouse.area) ? (`${warehouse.area} sq.ft`) : ('')} </span></div>
                                <div className="warehousing"><span>{(warehouse.hubs) ? (`${warehouse.hubs} hubs`) : ('')} </span></div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (
                <>
                    <div className="warehousingcard s-ware">
                        <div className="warehousingcontainer row">
                            <div className="col-12">
                                <span className="data_header"><b>Warehousing Services</b></span>
                            </div>
                            <div className="col">
                                <div className="warehousing"><span>Details not available</span></div>
                            </div>
                        </div>
                    </div>
                </>)
        }
    }
}

export default Warehousing
